import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, Input, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { SESSION_STORAGE } from '@ng-web-apis/common';

@Directive({
  selector: '[sharryViewport]',
  standalone: true,
})
export class ViewportDirective implements OnInit, AfterViewInit {
  @Input() sharryViewport = 'fade-in';
  @Input() uuid: string;

  private loadedBefore: boolean;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}
  ngOnInit(): void {
    this.loadedBefore = Boolean(this.sessionStorage.getItem(`${this.uuid}-viewport`));
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.loadedBefore) {
        this.renderer.addClass(this.el.nativeElement, 'not-in-viewport');
      }
      const inViewport: IntersectionObserverCallback = (entries, _observer) => {
        entries.forEach(entry => {
          if (!!entry.target.classList.contains('not-in-viewport') && entry.isIntersecting) {
            entry.target.classList.remove('not-in-viewport');
            this.sessionStorage.setItem(`${this.uuid}-viewport`, 'true');
          }
        });
      };
      const Obs = new IntersectionObserver(inViewport);
      Obs.observe(this.el.nativeElement);
    }
  }
}
